function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgMicrosoft = function SvgMicrosoft(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F15022"
    },
    fill: "#F15022",
    d: "M0 0h9v9H0z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7FBA00"
    },
    fill: "#7FBA00",
    d: "M10 0h9v9h-9z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#00A4EF"
    },
    fill: "#00A4EF",
    d: "M0 10h9v9H0z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFB900"
    },
    fill: "#FFB900",
    d: "M10 10h9v9h-9z"
  })));
};
export default SvgMicrosoft;